import {FeatureCollection, Polygon} from 'geojson';
import {booleanIntersects} from '@turf/boolean-intersects';

export const filterByTrafficCenter = async (fc: FeatureCollection, trafficCenter: string | null): Promise<FeatureCollection> => {
    if (!trafficCenter) {
        return Promise.resolve(fc);
    }

    const trafficCenterResponse = await fetch(`/assets/traffic-center-areas/${trafficCenter.toLowerCase()}.json`);

    if(!trafficCenterResponse.ok){
        return Promise.resolve(fc);
    }

    const trafficCenterPolygon = await trafficCenterResponse.json() as Polygon;

    return {
        ...fc,
        features: fc.features.filter(feature => booleanIntersects(feature.geometry, trafficCenterPolygon))
    };
};
